<template>
  <v-container>
    <v-row class="mb-5">
      <v-spacer></v-spacer>
      <v-menu offset-y left v-model="menu" :close-on-content-click="false" :close-on-click="false">
        <template v-slot:activator="{ on }">
          <v-btn class="primary" v-on="on">Filter <v-icon right dark>
              mdi-filter-variant
            </v-icon></v-btn>
        </template>
        <v-card class="pa-5" flat>
          <label for="">Date</label>
          <br />
          <DateRangePicker v-model="dateRange" />
          <v-card-actions>
            <v-btn rounded depressed @click="reset">Reset</v-btn>
            <v-btn color="primary" @click="load()" rounded depressed>Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-row>

    <v-row>
      <v-col cols="12" md="6" sm="12">
        <v-card elevation="2" class="mb-4">
          <v-card-text>
            <p>Total Coin Purchase</p>
            <p><strong>$ {{ formatMoney(tradeSumUSD || 0) }}</strong></p>
          </v-card-text>

        </v-card>
        <v-card elevation="2">
          <v-card-text>
            <p>Total Credit (NGN)</p>
            <p><strong>₦ {{ formatMoney(tradeSumNaira || 0) }}</strong></p>
          </v-card-text>

        </v-card>
      </v-col>
      <v-col cols="12" md="6" sm="12">
        <v-card>
          <v-card-title>
            <p>coins wallet</p>
          </v-card-title>
          <v-card-text>
            <walletTable :coins="coinStats"></walletTable>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <transactionsTable></transactionsTable>
      </v-col>
    </v-row>
  </v-container>


</template>


<script>

// import sound from '@/assets/Global/Sounds/notify.wav'

// =========== IMPORT SERVICE =========
import { StoresService, CryptoService } from "@/services";
import walletTable from "../components/wallet-table.vue";
import transactionsTable from "../components/transactions-table.vue";
import { formatMoney } from '@/utils/moneyFormatter';
import DateRangePicker from "@/components/DateRangePicker.vue";

export default {
  data: () => ({
    topTradersUsers: [],
    coinStats: [],
    tradeSumNaira: '',
    tradeSumUSD: '',
    loading: true,
    menu: false,
    dateRange: {
      startDate: null,
      endDate: null,
    },

  }),
  async mounted() {
    // this.getTopTraders();
    this.load();
  },
  methods: {
    formatMoney(amount) {
      return formatMoney(amount, false)
    },
    async load() {
      try {
        let data = await CryptoService.tradeSums(this.dateRange);
        let data2 = await CryptoService.coinStats(this.dateRange);
        this.coinStats = data2;
        this.tradeSumNaira = data.tradeSumNaira;
        this.tradeSumUSD = data.tradeSumUSD;
        this.menu = false;
      } catch (error) {
        this.loading = false;
      }
    },

    async getTopTraders() {
      try {
        this.
          topTradersUsers = [];
        this.loading = true;
        let data = await StoresService.loadTopTraders();
        this.loading = false;
        this.topTradersUsers = data;
      } catch (error) {
        this.loading = false;
      }
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    reset() {
      this.dateRange = {
        startDate: null,
        endDate: null,
      };
      this.load();
    }
  },
  components: {
    walletTable,
    transactionsTable,
    DateRangePicker
  },
};
</script>